import { type ObjectMode } from '@databases/types';
import {
  type Database,
  type DatabaseEntry,
  type DatabaseField,
  DatabaseFieldType,
  type DatabaseValue
} from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId, DEFAULT_IMPORT_DATABASE_FIELD_COUNT } from './constants';

const SCROLL_TEST_ENTRY_COUNT = 25;

const generateEntriesById = (
  baseDatabase: Database<ObjectMode.CREATE>,
  fields: DatabaseField[]
) => {
  const result: Record<string, DatabaseEntry> = {};

  for (const entry of Object.values(baseDatabase.entriesById)) {
    result[entry.id] = {
      id: entry.id,
      values: Object.fromEntries(
        fields.map((field) => [
          field.id,
          { type: 'text', id: '1', value: { plain: 'test' } }
        ])
      ) as Record<string, DatabaseValue<DatabaseFieldType, object>>
    };
  }

  return result;
};

export const getDatabaseWithSampleCsvManyRows = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getExistingDatabase({
    contentId: databasesToContentId['databaseWithSampleCsvManyRows'],
    entryCount: SCROLL_TEST_ENTRY_COUNT
  });

  const fields = [
    ...Array.from({ length: DEFAULT_IMPORT_DATABASE_FIELD_COUNT }, (_, index) => ({
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field ${index}`
    }))
  ];

  const entriesById = generateEntriesById(baseDatabase, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    entriesById,
    entries: Object.keys(entriesById)
  };
};
